import types from './mutation-types'

const mutations = {
	[types.LOGIN](state) {
		state.pending = true;
		state.loginFailed = false;
		state.isLoggedIn = false;
	},
	[types.LOGIN_SUCCESS](state, accessToken) {
		state.isLoggedIn = true;
		state.pending = false;
		state.accessToken = accessToken;
	},
	[types.LOGIN_FAILED](state, payload) {
		state.loginFailed = true;
		state.lastError = payload;
		state.pending = false;
	},
	[types.LOGOUT](state) {
		state.isLoggedIn = false;
		state.accessToken = null;
	},
	[types.SET_ME](state, user) {
		state.me = user;
	}
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js